import { ESaleType } from '../../../../api-models/common/json_query';

export const SALE_TYPES_MAP_VALUE_TO_LABEL = {
  [ESaleType.Any]: '',
  [ESaleType.F3]: '214-Ф3',
  [ESaleType.GSKContract]: 'Договор ЖСК',
  [ESaleType.Reassignment]: 'Переуступка',
  [ESaleType.PreliminaryContract]: 'Предварительный договор купли-продажи',
  [ESaleType.InvestmentContract]: 'Договор инвестирования',
  [ESaleType.Free]: 'Свободная',
  [ESaleType.Alternative]: 'Альтернатива',
};
